import { CSSProperties, useContext } from "react";
import "./css/LabelModule.css";
import QuestContext from "../../components/QuestWrapper";

interface Proptype {
  htmlFor?: string;
  style?: CSSProperties;
  children?: string;
  className?: string;
  id?: string;
}

export const LabelModule2 = ({
  htmlFor,
  style,
  children,
  className,
  id,
}: Proptype) => {
  const { themeConfig } = useContext(QuestContext.Context);

  return (
    <label
      htmlFor={htmlFor}
      style={{ color: themeConfig.primaryColor, ...style }}
      className={`q_modular_label ${className || ""}`}
      id={id}
    >
      {children}
    </label>
  );
};
